import React, { useState, useEffect } from 'react';
import { dateFormatConDiaYHoraShort, dateFormatConDiaShort } from '../../../../../utils/DateFunctions';

const DetallesInventario = (p) => {
    const data = p.data;
    useEffect(() => {

    }, [p.data]);

    const calcularDiasTranscurridos = (fecha, fechaFin, msj) => {
        const fechaActual = fechaFin ? new Date(fechaFin) : new Date();
        const fechaIngresada = new Date(fecha);
        const diferencia = fechaActual.getTime() - fechaIngresada.getTime();
        const diasTranscurridos = Math.floor(diferencia / (1000 * 60 * 60 * 24));
        return diasTranscurridos >= 0 ? diasTranscurridos : 0;
    };

    const agregarDias = (fecha, dias) => {
        const fechaIngresada = new Date(fecha);
        fechaIngresada.setDate(fechaIngresada.getDate() + dias);
        const year = fechaIngresada.getFullYear();
        const month = String(fechaIngresada.getMonth() + 1).padStart(2, '0');
        const day = String(fechaIngresada.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const calcularDiasFaltantes = (fecha) => {
        const fechaActual = new Date();
        const fechaIngresada = new Date(fecha);
        const diferencia = fechaIngresada.getTime() - fechaActual.getTime();
        const diasFaltantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));
        return diasFaltantes >= 0 ? diasFaltantes : `${Math.abs(diasFaltantes)} días vencido`;
    };

    const format = [
        {
            name: 'FECHAS', data: [
                { name: 'Fecha de inventareado', value: dateFormatConDiaYHoraShort(data.fecha_recepcion, 'No disponible') },
                { name: 'Días trascurridos desde inventariar', value: calcularDiasTranscurridos(data.fecha_recepcion) },
                { name: 'Inventariado por', value: data.recibido_por },
                { name: '' }, //bandera para generar un separador
                { name: 'Fecha de trasplante', value: dateFormatConDiaShort(agregarDias(data.fecha_trasplante, data.dia_trasplante), 'No disponible') },
                { name: 'Días desde ejecución de trasplante', value: !data.dia_ejecucion ? 'NO EJECUTADO' : calcularDiasTranscurridos(agregarDias(data.fecha_trasplante, data.dia_ejecucion)) },
                { name: "Día(s) ejecutados", value: data.diasEjecucion },
                { name: 'Ejecutado por', value: data.usuarios_ejecucion },
                { name: '' },
                { name: 'Fecha de corte', value: dateFormatConDiaShort(agregarDias(data.fecha_cosecha, data.dia_cosecha), 'No disponible') },
                { name: 'Días para llegar a fecha de corte', value: calcularDiasFaltantes(agregarDias(data.fecha_cosecha, data.dia_cosecha)) },
                { name: '' },
                { name: 'Días programados en campo', value: calcularDiasTranscurridos(agregarDias(data.fecha_trasplante, data.dia_trasplante), agregarDias(data.fecha_cosecha, data.dia_cosecha)) },

            ]
        },
        {
            name: "PLANTAS",
            data: [
                { name: "Presupuesto total", value: data.presupuesto_plantas },
                { name: "Plantas planeadas", value: data.numero_plantas },
                { name: "Plantas ejecutadas", value: data.plantas_ejecucion },
                { name: "Porcentaje perdida trasplante", value: data.plantas_ejecucion == 0 ? "No definida" : `${Math.ceil((data.numero_plantas - data.plantas_ejecucion) / data.numero_plantas * 100)} %` },
                { name: "Germinación de consolidación", value: `${data.germinacion}%` },
                { name: "" },
                { name: "Tallos planeados totales", value: data.tallos_teoricos },
                { name: "Tallos planeados segmento", value: Math.ceil(+data.presupuesto_plantas * +data.recuperacion_teorica) },
                { name: "Recuperación téorica", value: `${data.recuperacion_teorica} %` },
                { name: "Tallos recuperados", value: data.tallos_recuperados },
                { name: "" },
                { name: "Total de grados días", value: Math.round(data.grados_dias_acumulados ?? 0) },

            ]
        },
        {
            name: "UBICACIÓN Y EDICIÓN",
            data: [
                { name: "Camas", value: `${data.cama_inicio}-${data.cama_fin} (${data.cama_fin - data.cama_inicio + 1} camas)` },

                { name: "Metros ocupados", value: `${data.metros2_siembra} m2` },
                { name: "Densidad real", value: `${Math.round(data.plantas_ejecucion / data.metros2_siembra * 100) / 100}` },
                { name: "Electrificada", value: data.electrificada },
                { name: "HOOPS", value: data.hoops },
                { name: "Microaspersión", value: data.microaspersion },
                { name: "Tipo de agua", value: data.tipo_agua },
                { name: '' },
                { name: 'Última edición', value: dateFormatConDiaYHoraShort(data.fecha_edicion, 'No se ha editado aún') },
                { name: 'Último editor', value: data.ultimoEditor ?? 'Registro no editado' },
            ]
        }
    ]

    return (
        <div className='row justify-content-evenly w-100 m-0 p-0'>
            {format.map((f, i) => <div key={i} className='bw-400 mb-3 round-m border shadow-sm p-2'>
                <div className='w-100 text-bold mb-2 h4 text-center opacity-60'>{f.name}</div>
                {f.data.map((d, j) => d.name === "" ? <div className='w-70 border mb-2'></div>
                    : <div key={j} className='w-100 text-bold m-0 p-0 text-start'>{d.name}:
                        <span className='text-400 ms-2'>{d.value}</span>
                    </div>
                )}
            </div>)}
        </div>
    )
}

export default DetallesInventario;